import React, { useMemo } from 'react';
import { Card, List, Space, Tag, Typography } from 'antd';

const { Text } = Typography;

type OperationalEvent = {
  id: number;
  label: string;
  at: string;
};

type Props = {
  events: OperationalEvent[];
  loading?: boolean;
  maxItems?: number;
};

export const ExecutionEventTimeline: React.FC<Props> = ({
  events,
  loading = false,
  maxItems = 50
}) => {
  const visible = useMemo(() => events.slice(0, maxItems), [events, maxItems]);

  return (
    <Card size="small" title="История исполнения" loading={loading}>
      {visible.length === 0 ? (
        <Text type="secondary">События исполнения появятся по мере работы с маршрутом.</Text>
      ) : (
        <List
          size="small"
          dataSource={visible}
          renderItem={(item) => (
            <List.Item>
              <Space wrap>
                <Tag>{item.label}</Tag>
                <Text type="secondary" style={{ fontSize: 11 }}>
                  {new Date(item.at).toLocaleString('ru-RU')}
                </Text>
              </Space>
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default ExecutionEventTimeline;
